import { useSelector } from 'react-redux';
import { HomePurchaseGoalData } from './HomePurchase.meta';
import { GoalsDTO } from '../../api/useGoalsQuery';
import { AT_RETIREMENT } from '../../Goals.meta';
import { selectCurrentClient } from '../../../../CommonSelectors/CommonAreaSelector';

const FIELDS_TO_SHOW_ADVANCED = ['pmi', 'monthlyHoa', 'propertyTax', 'homeInsurancePerYear'];

interface Params {
  goalData: HomePurchaseGoalData;
  yearsOptions: GoalsDTO['yearsOptions'];
  mortgageTypeOptions: GoalsDTO['mortgageTypeOptions'];
}

export const useHomePurchase = ({ goalData, yearsOptions, mortgageTypeOptions }: Params) => {
  const { Dob: primaryDob, PartnerDob: spouseDob } = useSelector(selectCurrentClient);

  const primaryYob = primaryDob ? new Date(primaryDob).getFullYear() : null;
  const spouseYob = spouseDob ? new Date(spouseDob).getFullYear() : null;

  return {
    ...goalData,
    defaultShowAdvanced: FIELDS_TO_SHOW_ADVANCED.some(key => goalData[key] !== null),
    mortgageOptions: [{ label: 'No Mortgage', value: null }, ...mortgageTypeOptions],
    purchaseYearsOptions: [
      { label: AT_RETIREMENT, value: AT_RETIREMENT },
      ...yearsOptions.map(year => ({
        label: year.toString(),
        value: year,
        rightLabel: primaryYob
          ? `Age ${year - primaryYob}${spouseYob ? `, Age ${year - spouseYob}` : ''}`
          : undefined,
      })),
    ],
  };
};
